/* istanbul ignore file */
import React from 'react';
import { useShowContext } from 'framework/show';
import useActivityService from 'domain/sales/shared/timeline/activity/crmActivityService';
import useTransferActivityService from 'domain/sales/shared/timeline/activity/shared/transferActivityService';
import TransferCrmActivityToAnotherEntityButton from 'domain/sales/shared/timeline/activity/shared/Button/TransferCrmActivityToAnotherEntityButton';
import transferActivityValidation from 'domain/sales/shared/timeline/activity/shared/transferActivityValidation';
import { DeleteTimelineRecordButton } from 'domain/shared/timeline/button';
import PastDueMark from 'domain/sales/shared/timeline/activity/ActivityTimelineRecordLayout/PastDueMark';
import BaseTimelineRecordLayout from 'domain/shared/timeline/layout/BaseTimelineRecordLayout';
import { Collapsible } from 'framework/ui/field';
import ActivityFields from 'domain/sales/shared/timeline/activity/ActivityTimelineRecordLayout/ActivityFields';
import { TimelineType } from 'domain/shared/timeline/layout/BaseTimelineRecordLayout/timelineLayoutHelper';
import { READ_UNLINKED_CRM_ACTIVITY_PERMISSION } from 'domain/sales/unlinkedEmails/shared/unlinkedCrmActivitiesService';
import AddToBlacklistCrmActivityEmail from 'domain/sales/unlinkedEmails/shared/Button/AddToBlacklistCrmActivityEmail';

const UnlinkedActivityTimelineRecordLayout = ({ onEdit, ...props }: any) => {
  const { data } = useShowContext();
  const { deleteById, addToBlacklist } = useActivityService();
  const { transferActivity } = useTransferActivityService();

  const buttons = [
    <TransferCrmActivityToAnotherEntityButton
      key="transfer"
      permissionToCheck={READ_UNLINKED_CRM_ACTIVITY_PERMISSION}
      submitFormFunc={values => transferActivity(data.getValueBySource('id'), values)}
      timelineId={data.getValueBySource('timelineId')}
      modalTitle="Transfer CRM activity to another entity"
      getValidationSchemaFunc={() => Promise.resolve(transferActivityValidation)}
      isApplicable={!!data.getValueBySource('internetMessageId')}
    />,
    <AddToBlacklistCrmActivityEmail
      permissionToCheck={READ_UNLINKED_CRM_ACTIVITY_PERMISSION}
      deleteMethod={addToBlacklist}
      key="blacklist"
      id={data.getValueBySource('id')}
    />,
    <DeleteTimelineRecordButton
      permissionToCheck={READ_UNLINKED_CRM_ACTIVITY_PERMISSION}
      deleteMethod={deleteById}
      key="delete"
      id={data.getValueBySource('id')}
      timelineId={data.getValueBySource('timelineId')}
      entityName="activity"
    />,
  ];

  const actions = [<PastDueMark key="due-mark" />];

  const type = data.getValueBySource('activityType');

  return (
    <BaseTimelineRecordLayout
      fields={
        <Collapsible>
          <ActivityFields entity={data} />
        </Collapsible>
      }
      entity={data}
      buttons={buttons}
      actions={actions}
      timelineType={TimelineType[type]}
      {...props}
    />
  );
};

export default UnlinkedActivityTimelineRecordLayout;
